<form [formGroup]="formGroup">
    <div class="form-row">
        <div class="form-group col-md-6">
            <label for="cup">CUP*</label>
            <div class="input-group">
                <input class="form-control" id="cup" formControlName="cup" type="text">
                <!-- <div class="input-group-append btn-group" role="group">
                    <button type="button" class="btn btn-md btn-primary" (click)="checkCUP()">Verifica</button>
                    <button type="button" class="btn btn-md btn-secondary" (click)="resetCUP()">Resetta</button>
                </div> -->
            </div>
        </div>
        <!-- <div class="form-group col-md-3">
            <label for="codiceUnivoco">Codice univoco</label>
            <input class="form-control" id="codiceUnivoco" formControlName="codiceUnivoco" type="text">
        </div> -->
        <div class="form-group col-md-6">
            <label for="denominazione">Nome progetto*</label>
            <input class="form-control" id="denominazione" formControlName="denominazione" type="text"
                   [attr.title]="formGroup.get('denominazione')?.value">
        </div>
        <div class="form-group col-md-12">
            <label for="descrizione">Descrizione</label>
            <textarea class="form-control" id="descrizione" formControlName="descrizione"></textarea>
        </div>
        <div class="form-group" [ngClass]="'col-md-4'">
            <label for="sigla">Sigla</label>
            <input class="form-control" id="sigla" formControlName="sigla" type="text">
        </div>

        <div class="form-group" [ngClass]="'col-md-4'">
            <label for="importoEuro">Importo (€)</label>
            <input currencyMask [options]="{inputMode: natural,allowNegative: false, align: 'left', prefix: '€ ', thousands: '.', decimal: ',' }" class="form-control" id="importoEuro" formControlName="importoEuro" type="text">
        </div>
        <div class="form-group" [ngClass]="'col-md-4'">
            <label for="amministrazioneAggiudicatrice">Amministrazione aggiudicatrice</label>
            <input class="form-control" id="amministrazioneAggiudicatrice" formControlName="amministrazioneAggiudicatrice" type="text">
        </div>
        <div *ngIf="!disabledLabel" class="form-group col-md-3">
            <label for="progettista">Progettista</label>
            <input class="form-control" id="progettista" formControlName="progettista" type="text">
        </div>

        <div *ngIf="!disabledLabel" class="form-group col-md-3">
            <label for="studio">Studio</label>
            <input class="form-control" id="studio" formControlName="studio" type="text">
        </div>

        <div *ngIf="!disabledLabel" class="form-group col-md-3">
            <label for="impresa">Impresa</label>
            <input class="form-control" id="impresa" formControlName="impresa" type="text">
        </div>

        <div class="form-group col-md-12">
            <label for="vincoliPai">Vincoli PAI esistenti</label>
            <textarea class="form-control" id="vincoliPai" formControlName="vincoliPai"></textarea>
        </div>
        <div class="form-group col-md-12">
            <label for="note">Annotazioni</label>
            <textarea class="form-control" id="note" formControlName="note"></textarea>
        </div>
    </div>
</form>